import { DateTime } from 'luxon'

export type ChartExportFileNameParts = {
  page: string
  widget: string
  qualifier?: string
  from?: DateTime
  to?: DateTime
  now?: DateTime
}

function slugify(value: string): string {
  return (
    value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'unknown'
  )
}

function formatBoundary(dateTime?: DateTime): string {
  return dateTime?.isValid ? dateTime.toFormat('yyyy-MM-dd') : 'na'
}

export function buildChartExportFileName({ page, widget, qualifier, from, to, now }: ChartExportFileNameParts): string {
  const segments = [slugify(page), slugify(widget)]

  if (qualifier) {
    segments.push(slugify(qualifier))
  }

  segments.push(formatBoundary(from), formatBoundary(to))

  const timestamp = (now ?? DateTime.utc()).toUTC().toFormat("yyyyMMdd'T'HHmmss'Z'")

  return `${segments.join('_')}-${timestamp}.csv`
}
